/**
 * Zoho CRM Web-to-Lead: отправка через скрытый iframe (обход CORS, как у нативной HTML-формы Zoho).
 * Поля и скрытые токены берутся из формы в Zoho: Setup → объекты → Webforms / Web-to-Lead.
 */

function parseHiddenFields() {
  const raw = process.env.REACT_APP_ZOHO_WEBFORM_HIDDEN_JSON;
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    throw new Error("REACT_APP_ZOHO_WEBFORM_HIDDEN_JSON must be valid JSON.");
  }
}

export function isZohoWebToLeadConfigured() {
  const url = process.env.REACT_APP_ZOHO_WEBFORM_URL;
  const hidden = process.env.REACT_APP_ZOHO_WEBFORM_HIDDEN_JSON;
  return Boolean(url && hidden);
}

/**
 * Отправляет application/x-www-form-urlencoded POST в action формы Zoho.
 * Резолвится после submit (успех на стороне CRM без ответа в JS — как у классической формы).
 */
export function submitZohoWebToLead(leadFields) {
  const actionUrl = process.env.REACT_APP_ZOHO_WEBFORM_URL;
  if (!actionUrl) {
    return Promise.reject(new Error("REACT_APP_ZOHO_WEBFORM_URL is not set."));
  }

  const hidden = parseHiddenFields();
  const payload = { ...hidden, ...leadFields };

  return new Promise((resolve, reject) => {
    try {
      const iframeName = `zoho_wtl_${Date.now()}`;
      const iframe = document.createElement("iframe");
      iframe.name = iframeName;
      iframe.title = "Zoho Web-to-Lead";
      iframe.setAttribute("aria-hidden", "true");
      iframe.style.cssText = "position:absolute;width:0;height:0;border:0;visibility:hidden;";
      document.body.appendChild(iframe);

      const form = document.createElement("form");
      form.method = "POST";
      form.action = actionUrl;
      form.target = iframeName;
      form.acceptCharset = "UTF-8";

      Object.entries(payload).forEach(([name, value]) => {
        if (value === undefined || value === null) return;
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = String(value);
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      const cleanup = () => {
        clearTimeout(timer);
        if (form.parentNode) form.parentNode.removeChild(form);
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      };

      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve();
      };

      const timer = setTimeout(finish, 1200);
      iframe.onload = finish;
    } catch (e) {
      reject(e);
    }
  });
}
